import { numberToPrettyString } from '@cian/utils';
import * as React from 'react';

import { Container } from '../../components/Container';
import { Link } from '../../components/Link';
import { Text } from '../../components/Text';
import { SIZE_8 } from '../../constants/sizes';
import { IQuickLink } from '../../types/offersData';

interface IQuickLinksColumnsProps {
  quickLinks: IQuickLink[] | null;
  setPage(url: string): void;
}

export const QuickLinksColumnsContainer: React.StatelessComponent<IQuickLinksColumnsProps> = props => {
  const { quickLinks, setPage } = props;

  if (quickLinks === null) {
    return null;
  }

  return (
    <Container columnCount={4} margin={`0 0 -${SIZE_8} 0`}>
      {quickLinks.map((quickLink, index) => (
        <Container key={index} margin={`0 0 ${SIZE_8} 0`} display="flex">
          <Link url={quickLink.url} onClick={() => setPage(quickLink.url)} notChangeLocation>
            <Text fontSize={14} lineHeight={20} color="blue" colorHovered="red">
              {quickLink.title}
            </Text>
          </Link>
          <Container padding={`0 ${SIZE_8}`} display="inline">
            <Text fontSize={12} color="gray_4" whiteSpace="nowrap">
              {numberToPrettyString(quickLink.offersCount)}
            </Text>
          </Container>
        </Container>
      ))}
    </Container>
  );
};
